export default __webpack_public_path__ + "static/media/Hersteller_White-Piktogramm.8ad4a4a8.svg";